const CryptoJS = require('crypto-js');

// PKCE (Proof Key for Code Exchange) is an OAuth extension that adds additional security to the Authorization Code flow.
// Here we create the Code Verifier.
// See more details at https://tools.ietf.org/html/rfc7636
function createCodeVerifier(codeVerifier) {
    codeVerifier = CryptoJS.lib.WordArray.random(60).toString().slice(0, 128);
    return codeVerifier;
}

// PKCE (Proof Key for Code Exchange) is an OAuth extension that adds additional security to the Authorization Code flow.
// Here we create the Code Challenge.
// See more details at https://tools.ietf.org/html/rfc7636
function createCodeChallenge(codeVerifier) {
    const hash = CryptoJS.SHA256(codeVerifier);
    return hash.toString(CryptoJS.enc.Base64)
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
}

module.exports = {
    createCodeVerifier,
    createCodeChallenge
};
